// authSlice.js

import { createApi } from '@reduxjs/toolkit/query/react';
import { transformErrorResponse, transformSucessResponse } from '../../utils/API/responseMiddleware';
import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';
// import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { transformRequest } from '../../utils/API/requestMiddleware';

const authapi = createApi({
  baseQuery: defautBaseQuery, // Replace with your API endpoint
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: '/Authentication/UserLogin', // Replace with your authentication endpoint
        method: 'POST',
        body: transformRequest(credentials)
      }),
      invalidatesTags: ['authentication'],
      transformResponse:transformSucessResponse,
      transformErrorResponse:transformErrorResponse 
    }),
    

  }),
});

export const { useLoginMutation } = authapi;
export default authapi;
